var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollarCurrentcolor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13 10.2253c0-4.03587-6.16667-2.93517-6.16667-4.86538 0-.54237.51667-.81356 1.28334-.81356.7206 0 1.78642.27535 2.79743.70769.5226.22349 1.1489.03389 1.4045-.47375l.237-.47062c.2328-.46216.0758-1.0307-.3953-1.24462-.8734-.39654-1.9074-.67593-2.9603-.7839v-1.281161c0-.552284-.44771-.999999-1-.999999h-.2c-.55228 0-1 .447715-1 1v1.36092c-2.01667.3669-3.28333 1.54736-3.28333 3.25424 0 3.95613 6.16666 2.77567 6.16666 4.75374 0 .6381-.58333.9731-1.51666.9731-.9051 0-2.13302-.3708-3.19659-.9744-.55429-.3146-1.30032-.168-1.59711.396l-.18669.3548c-.224.4256-.11624.9563.29261 1.2098.9616.5961 2.11998 1.0204 3.32111 1.1992v1.4726c0 .5523.44771 1 1 1h.2c.55229 0 1-.4477 1-1v-1.4088c2.1833-.2393 3.8-1.3878 3.8-3.3659z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarCurrentcolor);
export default __webpack_public_path__ + "static/media/dollar-currentcolor.76709e8daf746438151e306ac2003f79.svg";
export { ForwardRef as ReactComponent };